import { HeroSection } from "./HeroSection";
import { MarqueeStrip } from "./MarqueeStrip";
import { FeaturesBento } from "./FeaturesBento";
import { RolesSection } from "./RolesSection";
import { ControlRoomSection } from "./ControlRoomSection";
import { CtaSection } from "./CtaSection";

export default function LandingPage() {
  return (
    <div data-testid="landing-page">
      <HeroSection />
      <MarqueeStrip />
      <FeaturesBento />
      <RolesSection />
      <ControlRoomSection />
      <CtaSection />
    </div>
  );
}
